import searchAutocompleteHtml from './searchautocomplete.html';
import './searchautocomplete.scss';

class SearchAutocompleteController {
    constructor($scope, $timeout, SearchAutocompleteService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = SearchAutocompleteService;
        this.loading = false;
        this.query = '';
        this.options = [];
        this.debounce = null;
        this.redirect = false;
        this.showModal = false;
        this.omitNextAutocomplete = false;
    }

    $onInit() {
        this.$scope.$watch(
            () => this.query,
            () => {
                this.refreshMatches();
            }
        );
    }

    refreshMatches() {
        if (this.omitNextAutocomplete) {
            return;
        }

        this.loading = true;
        this.options = [];

        if (this.debounce) {
            this.$timeout.cancel(this.debounce);
            this.debounce = null;
        }

        if (this.query === '') {
            this.loading = false;
            this.options = [];

            return;
        }

        this.debounce = this.$timeout(() => {
            this.service.matches(this.query).then(
                (response) => {
                    this.options = response.data;

                    angular.forEach(this.options, (options, key) => {
                        if (typeof response.data === 'object') {
                            let optionsArray = [];
                            for (let i in options) {
                                optionsArray.push(options[i]);
                            }
                            this.options[key] = optionsArray;
                        }

                        if (key !== 'products_categories') {
                            return;
                        }
                        angular.forEach(options, option => {
                            option.link = option.link + '?q=' + encodeURI(this.query);
                        });
                    });

                    this.loading = false;
                },
                () => {
                    this.loading = false;
                }
            );
        }, 500);

    }

    submit(query) {
        this.redirect = true;
        window.location.href = '/search/' + encodeURI(query);
    }

    select(match) {
        this.redirect = true;
        window.location.href = match.link;
    }
}

let searchAutocompleteComponent = {
    bindings: {},
    template: searchAutocompleteHtml,
    controller: SearchAutocompleteController
}

export default searchAutocompleteComponent;
